import React from 'react';
import Icon from '../../../components/AppIcon';
import { ACTION_TYPES } from '../../../services/auditLogService';

const STAT_CONFIG = [
  { key: ACTION_TYPES?.USER_CREATED, icon: 'UserPlus', color: 'text-green-600', bg: 'bg-green-50', border: 'border-green-200' },
  { key: ACTION_TYPES?.ROLE_CHANGED, icon: 'Shield', color: 'text-blue-600', bg: 'bg-blue-50', border: 'border-blue-200' },
  { key: ACTION_TYPES?.PM_TOGGLED, icon: 'ToggleLeft', color: 'text-purple-600', bg: 'bg-purple-50', border: 'border-purple-200' },
  { key: ACTION_TYPES?.INVITATION_SENT, icon: 'Mail', color: 'text-cyan-600', bg: 'bg-cyan-50', border: 'border-cyan-200' },
  { key: ACTION_TYPES?.USER_DEACTIVATED, icon: 'UserX', color: 'text-orange-600', bg: 'bg-orange-50', border: 'border-orange-200' },
  { key: ACTION_TYPES?.USER_REACTIVATED, icon: 'UserCheck', color: 'text-emerald-600', bg: 'bg-emerald-50', border: 'border-emerald-200' },
];

const AuditStatsBar = ({ logs }) => {
  const counts = logs?.reduce((acc, log) => {
    acc[log.action_type] = (acc?.[log?.action_type] || 0) + 1;
    return acc;
  }, {});

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
      {STAT_CONFIG?.map(({ key, icon, color, bg, border }) => (
        <div key={key} className={`${bg} border ${border} rounded-lg p-3 flex items-center gap-3`}>
          <div className={`w-8 h-8 rounded-md ${bg} flex items-center justify-center flex-shrink-0`}>
            <Icon name={icon} size={16} className={color} />
          </div>
          <div className="min-w-0">
            <p className={`text-lg font-bold ${color}`}>{counts?.[key] || 0}</p>
            <p className="text-xs text-muted-foreground truncate leading-tight">{key}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AuditStatsBar;
